import { Section, SubSection } from '@/sections/layout/Header/useGcssSections';
import { Category, mapSubcategoriesWithDescriptionAndImage } from './utils';
import { getCategoriesList } from '@/api/skippay/gcssCategories';
import { slugify } from '@/utils/string';
import { LINKS } from '@/constants/links';

const config = {
	cs: [
		// Děti a kojenci
		// Dům a zahrada
		// Elektronika
		// Oblečení a doplňky
		// Sportovní potřeby
		// Zdraví a krása
		537, 536, 222, 436, 166, 988,
	],
};

async function getCategoriesStructure(): Promise<Category[]> {
	const data = await getCategoriesList();

	const categories = data.filter((category) => category.path.length === 1);

	if (!categories) {
		throw new Error('No categories found');
	}

	const categoriesList = [];

	for (const category of categories) {
		const slug = slugify(category.path[0]);

		const subCategories = data.filter(
			(categoryItem) => categoryItem.path.length === 2 && categoryItem.path[0] === category.path[0]
		);

		const categoryMap = new Map<number, Category['subcategories'][number]>();

		if (subCategories) {
			for (const subCategory of subCategories) {
				categoryMap.set(subCategory.id, {
					slug: [slugify(subCategory.path[subCategory.path.length - 1])],
					title: subCategory.path[subCategory.path.length - 1],
					image: null,
				});
			}
		}

		const subcategories = await mapSubcategoriesWithDescriptionAndImage(category, categoryMap);

		categoriesList.push({
			...category,
			subcategories,
			name: category.path[0],
			slug,
			image: null,
			description: null,
		});
	}

	return categoriesList;
}

export async function getHeaderSections(): Promise<Section[]> {
	const primaryCategories = await getCategoriesStructure();

	const allCategories = await getCategoriesList();

	const selectedCategories = primaryCategories.filter((category) =>
		config.cs.includes(category.id)
	);

	const res = selectedCategories.map((category) => {
		const subsection: SubSection[] = category.subcategories.map((subcategory) => {
			const items = allCategories
				.filter((item) => {
					return (
						item.path.length === 3 &&
						item.path[0] === category.path[0] &&
						item.path[1] === subcategory.title
					);
				})
				.slice(0, 3)
				.map((item) => {
					return {
						id: item.id.toString(),
						name: item.path[item.path.length - 1],
						path: LINKS().gcssSubCategory(item.path.map((path) => slugify(path))),
					};
				});

			return {
				id: subcategory.slug[subcategory.slug.length - 1],
				name: subcategory.title,
				slug: subcategory.slug[subcategory.slug.length - 1],
				image: {
					alt: subcategory.title,
					src: subcategory.image || '',
				},
				path: LINKS().gcssSubCategory(subcategory.slug),
				items,
			};
		});

		return {
			id: category.id.toString(),
			name: category.name,
			slug: LINKS().gcssCategory(category.slug),
			subsection,
		};
	}) satisfies Section[];

	return res;
}
